module.exports = __webpack_public_path__ + "static/media/cheque.c7f51c71.png";